module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("\n\"EQUIPO\n"), (_vm.filteredTeams.length) ? _c('span', [_vm._v(_vm._s(_vm.filteredTeams[0].name))]) : _vm._e(), _vm._v(" -\n"), (_vm.filteredAccounts.length) ? _c('span', [_vm._v(_vm._s(_vm.filteredAccounts[0].name) + " " + _vm._s(_vm.filteredAccounts[0].country.prefix))]) : _vm._e(), _vm._v("\"\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71683cea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/partials/TitleCustom.vue
// module id = 458
// module chunks = 1